$shm_hitalama_draglist $mol_view
	some_dragged false
	ids? /
	ids_ordered? /
	remove_area_active? false
	items /
		<= Drag*0 $shm_hitalama_draglist_item
			on_drag_start? <=> on_drag_start*? null
			on_drag_end? <=> on_drag_end*? null
			dragged => dragged*
			top? <=> y*? 0
			left? <=> x*? 0
			sub /
				<= Item* $mol_view
					sub /
						<= id* \
